import { render, staticRenderFns } from "./table-cell.vue?vue&type=template&id=6371f995&scoped=true"
import script from "./table-cell.vue?vue&type=script&lang=js"
export * from "./table-cell.vue?vue&type=script&lang=js"
import style0 from "./table-cell.vue?vue&type=style&index=0&id=6371f995&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6371f995",
  null
  
)

export default component.exports